import {
  TRANSACTION_START,
  TRANSACTION_DATA,
  TRANSACTION_END,
} from "../../slices/type";

interface InitState {
  data: any[];
  dataSingle: any[];
  loading: boolean;
}

const initState: InitState = {
  data: [],
  dataSingle: [],
  loading: false,
};

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

const Transaction_Red = (state = initState, action: Action): InitState => {
  switch (action.type) {
    case TRANSACTION_START:
      return {
        ...state,
        loading: action.loading ?? false,
      };
    case TRANSACTION_DATA:
      return {
        ...state,
        data: action.payload ?? [],
        loading: action.loading ?? false,
      };
 
    case TRANSACTION_END:
      return {
        ...state,
        dataSingle: action.payload ?? [],
        loading: action.loading ?? false,
      };
    default:
      return state;
  }
};

export default Transaction_Red;
